import type { WorkspaceObject } from '../../types';
import { safeJsonDate } from './date';

export const normalizeWorkspaceObject = (data: WorkspaceObject<string> | null): WorkspaceObject | null => {
  if (!data) return null;

  return Object.assign(data, {
    createdOn: safeJsonDate(data.createdOn),
    expiresOn: data.expiresOn ? safeJsonDate(data.expiresOn) : undefined,
  });
};